import React, { FormEvent, ReactElement } from 'react';
import {
  Col,
  FormGroup,
  Heading,
  Label,
  LoaderButton,
  Row,
  Textarea,
} from 'idsk-react-components';
import { BackButton } from 'slovlex-idsk-react-components';

interface Props {
  poznamka: string;
  setPoznamka: (poznamka: string) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  loading: boolean;
}

const PoznamkaUpdateForm = ({
  poznamka,
  setPoznamka,
  onSubmit,
  loading,
}: Props): ReactElement => (
  <>
    <Heading size="l">Poznámky</Heading>
    <form onSubmit={onSubmit} className="admin-termin-create-form">
      <FormGroup>
        <Row>
          <Col width="two-thirds">
            <Label htmlFor="poznamka">Poznámky <span className="not-required"> (nepovinný údaj)</span></Label>
          </Col>
        </Row>
        <Row>
          <Col width="two-thirds">
            <Textarea
              name="poznamka"
              value={poznamka}
              onChange={({ target }) => setPoznamka(target.value)}
              maxLength={2048}
              rows={3}
              expandHeight
              showRemaining
            />
          </Col>
        </Row>
      </FormGroup>
      <Row className="admin-termin-create__actions">
        <Col width="one-half">
          <LoaderButton
            className="admin-termin-create__create-button"
            loading={loading}
            type="submit"
            size="large"
          >
            Uložiť zmeny
          </LoaderButton>
          <BackButton disabled={loading} />
        </Col>
      </Row>
    </form>
  </>
);

export default PoznamkaUpdateForm;
